<app-nav [titulo]="service ? 'Modificar servicio ' + service.nombre : 'Nuevo servicio'"
    [descripcion]="service ? 'Aquí podrá ver todos los detalles del servicio seleccionado y modificarlos.' : 'Por favor complete todos los datos del nuevo servicio.'">
    <div class="edit-service basic-avm-editor">
        <div class="form-stepper">
            <form class="form-step" [formGroup]="generalSectionFG">
                <h3 class="form-step-title">
                    {{ service ? 'Editar servicio' : 'Nuevo servicio' }}
                </h3>
                <span class="form-step-description">
                    {{ service ? 'Modifique los datos del servicio y guarde los cambios.' : 'Complete los datos del nuevo servicio.' }}
                </span>
                <div class="form-line">
                    <mat-form-field class="garantor-form-field" appearance="outline">
                        <mat-label>Código de servicio</mat-label>
                        <input matInput formControlName="codigo" onkeyup="this.value = this.value.toUpperCase();">
                        <mat-error *ngIf="generalSectionFG.controls['codigo'].hasError('required')">
                            Por favor ingrese un nombre
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="garantor-form-field" appearance="outline">
                        <mat-label>Nombre del servicio</mat-label>
                        <input matInput formControlName="nombre">
                        <mat-error *ngIf="generalSectionFG.controls['nombre'].hasError('required')">
                            Por favor ingrese un nombre
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="form-line">
                    <mat-form-field class="garantor-form-field" appearance="outline">
                        <mat-label>Descripción</mat-label>
                        <input matInput formControlName="descripcion">
                        <mat-error *ngIf="generalSectionFG.controls['descripcion'].hasError('required')">
                            Por favor ingrese una descripcion
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="form-line">
                    <mat-form-field class="garantor-form-field" appearance="outline">
                        <mat-label>Porcentaje</mat-label>
                        <input matInput formControlName="porcentajeDefault" type="number" style="text-align: right;">
                        <mat-error *ngIf="generalSectionFG.controls['porcentajeDefault'].hasError('required')">
                            Por favor ingrese un porcentaje
                        </mat-error>
                        <span matSuffix>&nbsp; %</span>
                    </mat-form-field>
                    <mat-form-field class="garantor-form-field" appearance="outline">
                        <mat-label>Depende de</mat-label>
                        <mat-select formControlName="pagador">
                            <mat-option value="PROPIETARIO">
                                Propietario
                            </mat-option>
                            <mat-option value="INQUILINO">
                                Inquilino
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="generalSectionFG.controls['pagador'].hasError('required')">
                            Por favor seleccione una opción
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="form-line">
                    <mat-form-field class="garantor-form-field" appearance="outline">
                        <mat-label>Tope máximo</mat-label>
                        <input matInput formControlName="topeMaximoDefault" type="number">
                        <mat-error *ngIf="generalSectionFG.controls['topeMaximoDefault'].hasError('required')">
                            Por favor ingrese un tope máximo
                        </mat-error>
                        <span matPrefix>$ &nbsp;</span>
                    </mat-form-field>
                    <mat-form-field class="garantor-form-field" appearance="outline">
                        <mat-label>Tope mínimo</mat-label>
                        <input matInput formControlName="topeMinimoDefault" type="number">
                        <mat-error *ngIf="generalSectionFG.controls['topeMinimoDefault'].hasError('required')">
                            Por favor ingrese un tope mínimo
                        </mat-error>
                        <span matPrefix>$ &nbsp;</span>
                    </mat-form-field>
                </div>
                <div class="form-step-buttons">
                    <button mat-button type="button" class="garantor-button" (click)="cancel()">Cancelar</button>
                    <button mat-raised-button color="primary" type="button" class="garantor-button" (click)="save()">
                        {{ service ? 'Guardar cambios' : 'Crear servicio' }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</app-nav>
